import Image from "next/image";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  /** "icon" = brand mark only (uses /iriswhite.png), "long" = full wordmark with tagline */
  variant?: "icon" | "long";
  /** Pixel size for icon variant (default 44) */
  size?: number;
  /** Width for long variant (default 200) */
  width?: number;
}

/**
 * IRIS logo component.
 * - variant="icon" → /iriswhite.png (brand mark, used in navbar / favicons / login)
 * - variant="long" → /logo-long.jpeg (full wordmark + tagline)
 */
export function Logo({ className, variant = "icon", size = 44, width = 200 }: LogoProps) {
  if (variant === "long") {
    return (
      <Image
        src="/logo-long.jpeg"
        alt="Institute for Real Estate and Infrastructure Strategy"
        width={width}
        height={Math.round(width * 0.56)}
        className={cn("object-contain", className)}
        priority
      />
    );
  }

  return (
    <Image
      src="/iriswhite.png"
      alt="IRIS"
      width={size}
      height={size}
      className={cn("object-contain", className)}
      priority
    />
  );
}
